






























import { Component, Vue } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
@Component
export default class ReferFriendBox extends Vue {
  get isLoggedIn() {
    return;
  }

  get companyCode() {
    return vxm.jobs.BrandingInfo.companycode;
  }

  get referaFriendTitle() {
    
    return vxm.users.getUserLang == 'fr' ? 
    vxm.configs.getGlobalConfigValue('REFER_A_FRIEND_TITLE_FR') 
    :vxm.configs.getGlobalConfigValue('REFER_A_FRIEND_TITLE');
  }

  get referralBannerURL() {
    return `${vxm.configs.getGlobalConfigValue(
      'CONTEXT_URL_COMPANY_LOGO_URL_ALIAS',
    )}/${vxm.jobs.BrandingInfo.companycode}/CANDIDATEPORTAL/ic_referbanner.png`;
  }

  get showReferFriendPopup() {
    return vxm.configs.getGlobalConfigValue('INTERNAL_REFERRAL_ENABLED');
  }

  onClickOnReferFriend() {
    if (this.showReferFriendPopup) {
      this.showReferAFriendPopup();
    } else {
      this.setRedirectAfterLoginOnReferNow();
      
      if (this.referFriendLink.startsWith('/')) {
        // Internal link, use router push
        this.$router.push(this.referFriendLink);
      } else {
        // External link, open in a new tab
        window.open(this.referFriendLink, '_blank');
      }
    }
  }

  showReferAFriendPopup() {
    this.$modal.show('refer-friend-popup');
  }

  setRedirectAfterLoginOnReferNow() {
    if (
      vxm.configs.getGlobalConfigBooelanValue('REFERFRIEND_AFTER_LOGIN_ONLY') &&
      !vxm.users.isLoggedIn
    )
      vxm.users.setRouteAfterLogin('ReferAFriend');
  }

  get referFriendLink() {
    if (this.referButtonLink) {
      return vxm.users.isLoggedIn ? this.referButtonLink : '/login';
    }
    if (vxm.users.isLoggedIn) {
      return '/referafriend';
    } else if (
      vxm.configs.getGlobalConfigBooelanValue('REFERFRIEND_AFTER_LOGIN_ONLY')
    ) {
      return '/login';
    } else {
      return '/anonreferafriend';
    }
  }

  get referralEnabled() {
    return vxm.configs.isReferralEnabled('REFERRAL_ENABLED');
  }

  get referButtonText() {
    return (
      vxm.configs.getGlobalConfigValue('REFER_FRIEND_BOX_BUTTON_TEXT') ||
      this.$t('referfriendbox.button.text')
    );
  }

  get referButtonLink() {
    return vxm.configs.getGlobalConfigValue('REFER_FRIEND_BOX_BUTTON_ROUTE');
  }
}
